export type IToast = {
  title: string
  body: string
  type: ToastType
  duration?: number
  autohide?: boolean
}

export enum ToastType {
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
}
